export const ASSET_DIR = '/assets/images/agri-output'

export const STRINGS = {
  PAGE_TITLE: 'DeHaat | Agri Output',
  PAGE_DESCRIPTION:
    'DeHaat connects farmers to suppliers and buyers on a single platform. Online marketplace providing all the agricultural products and services to farmers.',
  PAGE_HEADING: 'Agri Output',
  PAGE_SUBHEADING: 'Harvest & Market Access',
  DESCRIPTION:
    'Agri Output is cumulative result of nature\'s bounty and farmers ingenuity and hard work even so, unfortunately that does not always translate to deserving monetary rewards for the farmer.\n\nVariety of "middlemen" and logistical hurdles become serious impediments between Farmers and high-paying Institutional Buyers, resulting in lack of price transparency for farmer, price increase at both ends due to multiple handling, as well as post-harvest losses. In this process farmers do not receive good farm gate prices for their produce.\n\nThere is tremendous scope of technology-enabled disruption and development in this sector. DeHaat Technology Solution has been designed to create a transparent marketplace to provide direct market access to farmers and a reliable supply chain for large institutional buyers. With our "last mile connection" with the farmers and their farms, we continue direct on-field monitoring over quantity and quality over the produce growth cycle and provide full logistical support for harvesting and transportation, storage at conveniently located DeHaat Collection Centers - thus eliminating distress selling and the meddling middlemen that has been affecting Farmers in India for generations. This has resulted an increment of up to 20% gate prices for the farmer.',
  OUR_BRAND: 'Our Brand',
  BRAND_DESCRIPTION:
    "FarmPlus is an initiative of DeHaat aimed at connecting farmers to retailers, offering best quality products and enabling right price realisation.\n\nWith 4,00,000 MT of fresh and dry produce processed yearly and almost 8000 agri orders per day, Farm Plus has become one of India's largest distributors and importers of these ...",
  KNOW_MORE: 'KNOW MORE',
  BENEFITS: 'Benefits To Output Buyers',
  VISIBILITY: 'Visibility Of Supplies With Assured Quality',
  NO_OPERATIONAL_BURDEN:
    'No Operational Burden Of Managing Operations At Village Level',
  CUSTOMIZATION: 'Scope Of Customization In Production',
  DIRECT_ACCESS: 'Direct Access To Farmers',
  SORTING_AND_GRADING: 'Customized Sorting And Grading At Farm Gate',
  FACILITIES_AVAILABLE: 'Facilities Available',
  IN_HOUSE: 'In House Packhouse Availability',
  AUTO_SORTING_GRADING: 'Auto Sorting/Grading Systems',
  FRUIT_AND_VEGETABLE: 'Fruit And Vegetable Cleaning And Drying Systems',
  SULPHITE_FUMIGATION: 'Sulphite Fumigation Treatment Chambers',
  BANANA_RIPENING: 'Banana Ripening Chambers',
  PRECOOLING: 'Precooling And Cold Chambers',
  TRAINED_MANPOWER:
    'Trained Manpower To Customize Quality And Size Requirement',
  CUMIN: 'Cumin',
  CUMIN_DESC: 'Rajasthan (Barmer, Jaisalmer)',
  CORIANDER: 'Coriander',
  CORIANDER_DESC: 'Rajasthan (Kota, Ramganj Mandi)',
  FENNEL: 'Fennel',
  FENNEL_DESC: 'Rajasthan (Nagaur)',
  RED_CHILLI: 'Red Chilli',
  RED_CHILLI_DESC:
    'Andhra Pradesh, Telangana, Karnataka, Tamil Nadu, Madhya Pradesh, Assam',
  TURMERIC: 'Turmeric',
  TURMERIC_DESC:
    'Andhra Pradesh, Maharashtra, Odisha, Telangana, Karnataka, Tamil Nadu',
  BLACK_PEPPER: 'Black Pepper',
  BLACK_PEPPER_DESC: 'Andhra Pradesh, Karnataka, Kerala, Tamil Nadu',
  CARDAMOM: 'Cardamom',
  CARDAMOM_DESC: 'Kerala (Idukki)',
  ISO20000: 'ISO 20000',
  SBI: 'Spices Board India',
  GMP: 'GMP',
  BRCGS: 'BRC Global Standard',
  OTHER_SPICES: ['Fennel', 'Fenugreek', 'Black Pepper', 'Cardamom', 'Clove'],
  MAJOR_SPICES: ['Red Chilli', 'Turmeric', 'Cumin', 'Coriander'],
  OTHER_SPICES_TITLE: 'Other Spices',
  OTHER_SPICES_DESCRIPTION: 'Along with the major spices, we also offer:',
  TITLE: 'Premium Spices by DeHaat',
  SUBTITLE: 'Major Spices We Offer',
  SOURCING_REGIONS: 'Sourcing Regions',
  OUR_CERTIFICATIONS: 'Our Certifications',
  SOWING_HARVESTING_CALENDAR: 'Sowing & Harvesting Calendar',
  ABOUT_SOWING_HARVESTING:
    ' To maintain the highest quality and freshness, our spices are cultivated following a <@>sowing and harvesting cycle</@>:',
  BACKWARD_INTEGRATION_PROGRAMME: 'Our Backward Integration Programme',
  ABOUT_DEHAAT_DETAILED:
    'DeHaat brings you a premium selection of <@>sustainably grown spices</@>, sourced directly from the heartland of India. Our spices are cultivated using the highest quality standards to ensure <@>purity, traceability, and rich flavors</@>.',
  ABOUT_BACKWARD_INTEGRATION_PROGRAMME:
    'At DeHaat, we are committed to <@>sustainability, traceability, and farmer empowerment</@> through our <@>Backward Integration Programme</@>. Our initiative focuses on both <@>Integrated Pest Management (IPM) and Non-Integrated Pest Management (NIPM) varieties</@>, ensuring:',
  BACKWARD_INTEGRATION_BENEFITS: [
    'Sustainable farming practices',
    'End-to-end traceability',
    'Premium product quality',
    'Stronger, transparent supply chains',
  ],
  BACKWARD_INTEGRATION_PROGRAMME_AREAS: 'Backward Integration Programme Areas',
  ABOUT_CERTIFICATION:
    'We are continuously enhancing our quality standards, and <@>GAP</@> certification will be added soon.',
  BACKWARD_INTEGRATION_PROGRAMME_PROGRESS:
    'Currently, our program involves <@>2,638 farmers</@> across <@>23,483 acres</@> of land, covering key spices.',
  HARVEST_CALENDAR_IMAGE: [
    'harvest-calendar-red-chilli',
    'harvest-calendar-turmeric',
    'harvest-calendar-cumin',
    'harvest-calendar-coriander',
  ],
}

export const BENEFITS = [
  {
    image: `${ASSET_DIR}/product`,
    label: STRINGS.VISIBILITY,
  },
  {
    image: `${ASSET_DIR}/risk`,
    label: STRINGS.NO_OPERATIONAL_BURDEN,
  },
  {
    image: `${ASSET_DIR}/online-payment`,
    label: STRINGS.CUSTOMIZATION,
  },
  {
    image: `${ASSET_DIR}/temperature`,
    label: STRINGS.DIRECT_ACCESS,
  },
  {
    image: `${ASSET_DIR}/sort`,
    label: STRINGS.SORTING_AND_GRADING,
  },
]

export const FACILITIES = [
  {
    image: `${ASSET_DIR}/examination`,
    label: STRINGS.AUTO_SORTING_GRADING,
  },
  {
    image: `${ASSET_DIR}/diet`,
    label: STRINGS.FRUIT_AND_VEGETABLE,
  },
  {
    image: `${ASSET_DIR}/chamber`,
    label: STRINGS.SULPHITE_FUMIGATION,
  },
  {
    image: `${ASSET_DIR}/chamber`,
    label: STRINGS.BANANA_RIPENING,
  },
  {
    image: `${ASSET_DIR}/cold-room`,
    label: STRINGS.PRECOOLING,
  },
  {
    image: `${ASSET_DIR}/medal`,
    label: STRINGS.TRAINED_MANPOWER,
  },
]

export const SPICES_SOURCING_REGION = [
  {
    heading: STRINGS.CUMIN,
    description: STRINGS.CUMIN_DESC,
    icon: ``,
    image: `${ASSET_DIR}/map`,
    imageAlt: 'Source region map of spices',
  },
  {
    heading: STRINGS.CORIANDER,
    description: STRINGS.CORIANDER_DESC,
    icon: ``,
    image: `${ASSET_DIR}/map`,
    imageAlt: 'Source region map of spices',
  },
  {
    heading: STRINGS.FENNEL,
    description: STRINGS.FENNEL_DESC,
    icon: ``,
    image: `${ASSET_DIR}/map`,
    imageAlt: 'Source region map of spices',
  },
  {
    heading: STRINGS.RED_CHILLI,
    description: STRINGS.RED_CHILLI_DESC,
    icon: ``,
    image: `${ASSET_DIR}/map`,
    imageAlt: 'Source region map of spices',
  },
  {
    heading: STRINGS.TURMERIC,
    description: STRINGS.TURMERIC_DESC,
    icon: ``,
    image: `${ASSET_DIR}/map`,
    imageAlt: 'Source region map of spices',
  },
  {
    heading: STRINGS.BLACK_PEPPER,
    description: STRINGS.BLACK_PEPPER_DESC,
    icon: ``,
    image: `${ASSET_DIR}/map`,
    imageAlt: 'Source region map of spices',
  },
  {
    heading: STRINGS.CARDAMOM,
    description: STRINGS.CARDAMOM_DESC,
    icon: ``,
    image: `${ASSET_DIR}/map`,
    imageAlt: 'Source region map of spices',
  },
]

export const CERTIFICATE_LIST = [
  {
    image: `${ASSET_DIR}/certificate-brcgs`,
    alt: STRINGS.BRCGS,
  },
  {
    image: `${ASSET_DIR}/certificate-iso`,
    alt: STRINGS.ISO20000,
  },
  {
    image: `${ASSET_DIR}/certificate-gmp`,
    alt: STRINGS.GMP,
  },
  {
    image: `${ASSET_DIR}/certificate-sbi`,
    alt: STRINGS.SBI,
  },
]
